import { isProduction } from './env'

export const DSN = process.env.SENTRY_DSN
export const ENVIRONMENT = isProduction() ? 'production' : 'development'
export const RELEASE = process.env.SENTRY_RELEASE
